const TYPE_SCENE = 'scene';
const TYPE_WC = 'wc';
const TYPE_ENTRY_EXIT = 'entry_exit';
const TYPE_OTHER = 'other';

export {
    TYPE_SCENE,
    TYPE_WC,
    TYPE_ENTRY_EXIT,
    TYPE_OTHER,
};
